export enum ColumnType {
  created = "created",
  collectionYardName = "collectionYardName",
  wasteTypes = "wasteTypes",
  wasteSum = "wasteSum",
  priceSum = "priceSum",
  paidAt = "paidAt",
}

export const columnLabels = Object.values(ColumnType);
